import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sort' })
export class ArraySortPipe  implements PipeTransform {
    public transform(array: any[], field: string): any[] {
        if (!array || !Array.isArray(array)) {
            return array;
        }
        // Create a copy to avoid mutating read-only arrays (e.g., from NgRx store)
        return [...array].sort((a: any, b: any) => {
            if (a[field] < b[field]) {
                return -1;
            } else if (a[field] > b[field]) {
                return 1;
            } else {
                return 0;
            }
        });
    }
}
